export function catId(id: number): string {
  return `CAT-${String(id).padStart(3, "0")}`;
}

export function venId(id: number): string {
  return `VEN-${String(id).padStart(3, "0")}`;
}

export function itmId(id: number): string {
  return `ITM-${String(id).padStart(4, "0")}`;
}

export function memId(id: number): string {
  return `MEM-${String(id).padStart(4, "0")}`;
}

export function plnId(id: number): string {
  return `PLN-${String(id).padStart(3, "0")}`;
}

export function vipId(id: number): string {
  return `VIP-${String(id).padStart(4, "0")}`;
}

export function stkInId(id: number): string  { return `STK-IN-${String(id).padStart(3, "0")}`; }
export function stkOutId(id: number): string { return `STK-OUT-${String(id).padStart(3, "0")}`; }
export function chgId(id: number): string    { return `CHG-${String(id).padStart(3, "0")}`; }
export function dosId(id: number): string    { return `DOS-${String(id).padStart(3, "0")}`; }
export function entId(id: number): string    { return `ENT-${String(id).padStart(3, "0")}`; }
/** Phase 22 — Stock-In Order display identifier. e.g. ORD-001 */
export function ordId(id: number): string    { return `ORD-${String(id).padStart(3, "0")}`; }
